export { Text } from './Text';
export type { TextSizeClass, TextProps } from './Text';

export { StyledText } from './Text.styles';
